import { PageRouteBuilder } from "@common/route/page-route-builder";
import { CacheStatusPageComponent } from "./cache-status-page.component";

export const cacheStatusPageRoute = new PageRouteBuilder()
    .usingNgComponent("adapt-cache-status-page", CacheStatusPageComponent)
    .requiresLogin()
    .atUrl("/tools/cache-status")
    .withTitle("Cache Status")
    .build();
